import clsx from 'clsx'

import { usePSNavigate } from '../../../hooks/usePSNavigate'
import { useResponsiveSize } from '../../../hooks/useResponsiveSize'
import Button from '../../app/design/Button'
import Heading from '../../app/design/Heading'
import Paragraph from '../../app/design/Paragraph'

export function AlertReaderPage() {
    const navigate = usePSNavigate()

    const { vh } = useResponsiveSize()

    return (
        <div
            className={clsx('-m-1 mx-auto max-w-[648px] rounded-lg bg-gray-200', {
                'absolute top-1/2 right-0 left-0 -translate-y-1/2': vh >= 850,
            })}
        >
            <div className="relative h-[230px] overflow-hidden">
                <img
                    src="/card-reader.png"
                    className="absolute right-0 -bottom-12 left-0 mx-auto h-[250px] overflow-hidden"
                />
            </div>
            <div className="rounded-b-lg bg-white p-8 text-center">
                <Heading size="xl" className="text-gray-700">
                    Card reader
                </Heading>
                <Paragraph size="md" className="mt-4 mb-10 text-gray-600">
                    Swipe, tap magnetic stripe, or read chip cards
                </Paragraph>
                <div className="flex flex-col gap-3">
                    <Button intent="primary" onClick={() => navigate('/settings/reader/checkout')}>
                        Order a card reader
                    </Button>
                    <Button intent="secondary" onClick={() => navigate('/settings/reader/add')}>
                        Add an existing reader
                    </Button>
                    <Button
                        intent="tertiary_deprecated"
                        onClick={() =>
                            window.open('https://pocketsuite.io/feature/pos-payments/', '_blank')
                        }
                    >
                        Learn more
                    </Button>
                </div>
            </div>
        </div>
    )
}
